// Import model
import { ObjectTaskCondition } from '../models/ObjectTaskCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ObjectTaskIndexedFields } from '../models/ObjectTaskIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ObjectTaskIndexedFieldsSerializer } from './ObjectTaskIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ObjectTaskCondition - handles JSON serialization and deserialization with type validation
 */
export class ObjectTaskConditionSerializer {
  /**
   * Deserializes a JSON string into a ObjectTaskCondition instance
   */
  static deserialize(json: string): ObjectTaskCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ObjectTaskCondition instance
   */
  static fromObject(obj: any): ObjectTaskCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ObjectTaskCondition');
    }


    const instance: ObjectTaskCondition = {
      fieldName: obj['fieldName'] as ObjectTaskIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ObjectTaskCondition instances
   */
  static deserializeArray(json: string): ObjectTaskCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ObjectTaskCondition instance to a JSON string
   */
  static serialize(instance: ObjectTaskCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ObjectTaskCondition instance to a plain object
   */
  static toObject(instance: ObjectTaskCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ObjectTaskCondition instances to a JSON string
   */
  static serializeArray(instances: ObjectTaskCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
